import React, {  useState, useContext, useEffect, useRef } from 'react';
import { AuthContext, Card, ChatInput, Chart } from 'components/lib';
import { NavLink } from "react-router-dom";
import axios from 'axios';
import Markdown from 'markdown-to-jsx'

export function Chat(props){

  // const [analysisDetails, setAnalysisDetails] = useState({});
  const authContext = useContext(AuthContext);
  
  const [messages, setMessages] = useState([]);
  const [currMessage, setCurrMessage] = useState("");
  const [thread, setThread] = useState(undefined)
  const [chatCharts, setChatCharts] = useState([]); // Store chart objects with message index

  // const [connections, setConnections] = useState([]);
  // const [realms, setRealms] = useState([]);
  // const list = useAPI('/api/app_connection');
  // var analysis = useAPI('/api/appData/analysis/' + authContext.user.appConnection)

  // useEffect(() => {
  //   if(analysis.data){
  //       // alert(JSON.stringify(analysis.data[0]))
  //       setAnalysisDetails(analysis.data[0])
  //   }
  // }, [analysis]);

  // const latestMessageIndex = messages.length - 1; // Index of the latest message

  // Utility: detect chart definition in a string (expects JSON with a 'chart' key)
  function extractChartFromText(text) {
    try {
      const obj = JSON.parse(text);
      if (obj && obj.chart && obj.chart.type && obj.chart.data) {
        // Detected chart
        return obj.chart;
      }
    } catch (e) {}
    return null;
  }

  const processChatInput = async (value) => {
    setIsProcessing(true);
    const newMsg = {
      position: "right",
      type: "text",
      title: "",
      text: value,
    };
    setMessages(current => [...current, newMsg]);

    // Processing chat input
    var data = {
      headers: {
        responseType: 'stream'
      },
      app_connection_id: authContext.user.app_connection_id,
      message: value,
      thread: thread
    }
    const headers = {
      ...axios.defaults.headers.common,
      'Content-Type': 'application/json',
      responseType: 'stream'
    };
    const res = await fetch('/api/chatai', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data)
    });

    // Try to parse a chart response (non-stream)
    let isChart = false;
    try {
      const cloned = res.clone();
      const text = await cloned.text();
      // Checking for chart in response
      const chartObj = extractChartFromText(text);
      if (chartObj) {
        setIsProcessing(false);
        setCurrMessage(undefined);
        // Extract chart title if present
        const chartTitle = chartObj.title || chartObj.chartTitle || chartObj.data?.title || (chartObj.type ? (chartObj.type.charAt(0).toUpperCase() + chartObj.type.slice(1) + ' Chart') : 'Chart');
        setMessages(current => [...current, { position: "left", type: "chart", title: chartTitle, text: undefined }]);
        setChatCharts(current => [...current, { chart: chartObj, msgIdx: messages.length + 1, chartTitle }]);
        isChart = true;
        return;
      }
    } catch (e) { /* Not a chart, continue as stream */ }

    if (res.ok && res.body && !isChart) {
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let currMessage = "";
      let currChart = null;
      function getLastValidJson(streamText) {
        const jsonPattern = /({[^}]*})/g;
        let lastValidJson = null;
        let match;
        while ((match = jsonPattern.exec(streamText)) !== null) {
          try {
            lastValidJson = JSON.parse(match[1]);
          } catch (error) {}
        }
        return lastValidJson;
      }
      const processStream = async () => {
        let firstChunkReceived = false;
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            setIsProcessing(false);
            break;
          }
          const chunkText = decoder.decode(value);
          const chartObj = extractChartFromText(chunkText);
          if (chartObj) {
            currChart = chartObj;
            setCurrMessage(undefined);
          }
          const json = getLastValidJson(chunkText);
          if (json && json.thread !== undefined) {
            if (thread === undefined) {
              setThread(json.thread);
            }
          } else if (json) {
            currMessage = json.text;
            setCurrMessage(currMessage);
            if (!firstChunkReceived) {
              setIsProcessing(false);
              firstChunkReceived = true;
            }
          }
        }
        const newResMsg = {
          position: "left",
          type: currChart ? "chart" : "text",
          title: currChart ? (currChart.title || currChart.chartTitle || currChart.data?.title || (currChart.type ? (currChart.type.charAt(0).toUpperCase() + currChart.type.slice(1) + ' Chart') : 'Chart')) : "",
          text: currChart ? undefined : currMessage,
        };
        setCurrMessage(undefined);
        setMessages(current => {
          const updated = [...current, newResMsg];
          if (currChart) {
            setChatCharts(charts => [...charts, { chart: currChart, msgIdx: updated.length - 1, chartTitle: newResMsg.title }]);
          }
          return updated;
        });
      };
      processStream();
    } else if (!isChart) {
      // Error processing response
    }
  }


const divRef = useRef(null);
const [processingDots, setProcessingDots] = useState('.');
const [isProcessing, setIsProcessing] = useState(false);

// Animate the processing dots when waiting for a response
useEffect(() => {
  if (isProcessing) {
    const interval = setInterval(() => {
      setProcessingDots((prev) => (prev.length < 3 ? prev + '.' : '.'));
    }, 500);
    return () => clearInterval(interval);
  } else {
    setProcessingDots('.');
  }
}, [isProcessing]);

// Always scroll to bottom when messages or currMessage changes
useEffect(() => {
  if (divRef.current) {
    divRef.current.scrollTop = divRef.current.scrollHeight;
  }
}, [messages, currMessage]);


  return (
    <>
      <nav className='subnav'>
      <NavLink exact to='/client/ai' activeClassName='active'>Chat</NavLink>
      <NavLink exact to='/client/ai/agents' activeClassName='active'>Agents</NavLink>
      <NavLink exact to='/client/ai/analysis' activeClassName='active'>Analysis</NavLink>
      </nav>

        <div style={{ marginBottom: '0px'}}>
        <Card minHeight='388px'>
            <div style={{paddingBottom: 20}}>
                <div style={{marginTop: '16px', paddingRight: '10px', fontSize: '20px'}}>Use the LedgerView AI Assistant to answer questions about your business</div>
                {/* <div style={{paddingBottom: '12px'}}><b>Date Analyzed: {analysisDetails.date}</b></div> */}

                {/* <div>
                    <div style={{paddingBottom: '12px'}}>
                        <div><b>Summary:</b></div>
                        <div>{analysisDetails.details?.summary}</div>
                    </div>

                    <div style={{paddingBottom: '12px'}}>
                        <div><b>Potential Risks:</b></div>
                        {analysisDetails.details?.risks?.map((item, index) => {
                            return(<div> {index+1}. {item.risk.text}</div>)
                        })}
                    </div>

                    <div style={{paddingBottom: '12px'}}>
                        <div><b>Positives:</b></div>
                        {analysisDetails.details?.positives?.map((item, index) => {
                            return(<div> {index+1}. {item.positive.text}</div>)
                        })}
                    </div>
                </div> */}
            </div>
        
            {/* <MessageList
              className='message-list'
              lockable={true}
              toBottomHeight={'100%'}
              dataSource={messages}
            /> */}

<div style={{ 
      height: '450px', 
      display: 'flex',
      width: '100%'
    }}>

<div 
ref={divRef} 
style={{ 
  height: '85%', 
  width: '100%',
  overflowY: 'auto', 
}}>
            {
              messages.map((msg, idx) => {
                if (msg.type === 'chart') {
                  // Find chart for this message
                  const chartObj = chatCharts.find(c => c.msgIdx === idx);
                  if (chartObj) {
                    // Determine chart title
                    const chartTitle = chartObj.chart.title || chartObj.chart.chartTitle || chartObj.chart.data?.title || (chartObj.chart.type ? (chartObj.chart.type.charAt(0).toUpperCase() + chartObj.chart.type.slice(1) + ' Chart') : 'Chart');
                    return (
                      <div key={idx} style={{
                        paddingBottom: '24px',
                        justifyContent: 'flex-start',
                      }}>
                        <div style={{
                          fontWeight: 'bold',
                          width: '100%'
                        }}>{'LedgerView AI (Chart)'}</div>
                        {/* Chart Title */}
                        <div style={{
                          fontWeight: 600,
                          fontSize: '1.1em',
                          marginBottom: '4px',
                          marginTop: '8px',
                          color: '#222',
                          maxWidth: '80%'
                        }}>{chartTitle}</div>
                        <div style={{
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                          background: '#fafbfc',
                          padding: '16px',
                          maxWidth: '80%',
                          marginTop: '4px',
                          marginLeft: 0,
                          marginRight: 'auto',
                        }}>
                          <Chart type={chartObj.chart.type} data={chartObj.chart.data} options={chartObj.chart.options || {}} />
                        </div>
                      </div>
                    );
                  }
                }
                // Default: render as text
                return(
                  <div key={idx} style={{paddingBottom: '24px'}}>
                    <div style={{fontWeight: 'bold'}}>{msg.position === 'right' ? 'You' : 'LedgerView AI'}</div>
                    <Markdown>{msg.text}</Markdown>
                  </div>
                )
              })
            }

            {
              currMessage && 
                  <div style={{paddingBottom: '24px'}}>
                    <div style={{fontWeight: 'bold'}}>{'LedgerView AI'}</div>
                    <Markdown>{currMessage}</Markdown>
                  </div>
            }
            {
              isProcessing && 
                  <div style={{paddingBottom: '24px'}}>
                    <div style={{fontWeight: 'bold'}}>{'LedgerView AI'}</div>
                    <div style={{fontStyle: 'italic', color: 'gray'}}>Processing{processingDots}</div>
                  </div>
            }
</div>
</div>
<div style={{ position: 'absolute', bottom: 20, left: 20, right: 20}}>
  {/* Your content here */}

            <ChatInput callback={processChatInput} />

</div>
{/* <Input
  referance={inputReferance}
  placeholder="Type here..."
  multiline={true}
  rightButtons={<Button text='Send' 
  onClick={(msg) => alert('here - ' + inputReferance)} />}
/> */}
        {/* <TextField fullWidth multiline 
          inputProps={{
            sx: {
              fontSize: '16px',
              lineStepHeight: '200px'
            }
          }}
          InputLabelProps={{
            sx: {
              fontSize: '20px'
            },
          }} 
        label="" id="fullWidth"
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            alert(e.target.value);
            e.preventDefault();
          }
        }}
        />

        <Button variant='outlined' size="medium" label='Go' onClick={(e) => {
            alert('hello');
        }}>Go</Button> */}
        {/* endIcon={<SendIcon />} */}
        </Card>
        </div>
      
      

<div>

</div>

    
    </>
  );
}
